import { useEffect } from "react";

const SITE = "VIA PRIME Luxury";
const DEFAULT_DESC =
  "VIA PRIME Luxury — İstanbul merkezli kurumsal uzun dönem lüks araç kiralama. Sıfır bakım riski, vergi avantajı ve 7/24 destek ile 2026 model sıfır km premium sedan filosu.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Sayfa başlığı, açıklama, canonical ve paylaşım (Open Graph) etiketlerini ayarlar.
export function usePageMeta({ title, description, image } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | İstanbul Kurumsal Filo Kiralama`;
    const desc = (description || DEFAULT_DESC).replace(/\s+/g, " ").slice(0, 160);
    const url = `https://viaprimeluxury.com${window.location.pathname}`;
    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    if (image) setMeta("property", "og:image", image);
    setCanonical(url);
  }, [title, description, image]);
}
